import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import 'luxon';
import styled from 'styled-components';
import '../../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import 'lodash';
import ThemedComponentWrapper from '../../../../theme/ThemedComponentWrapper.js';
import '../../../icons/ActivityIcon.js';
import '../../../icons/ArrowDownIcon.js';
import '../../../icons/ArrowDownRightCircleIcon.js';
import '../../../icons/ArrowLeftAlignIcon.js';
import '../../../icons/ArrowLeftIcon.js';
import '../../../icons/ArrowRightAlignIcon.js';
import '../../../icons/ArrowRightIcon.js';
import '../../../icons/ArrowSwitchIcon.js';
import '../../../icons/ArrowUpIcon.js';
import '../../../icons/ArrowUpRightCircleIcon.js';
import '../../../icons/ArrowsAngleExpandIcon.js';
import '../../../icons/BankIcon.js';
import '../../../icons/CheckIcon.js';
import '../../../icons/ChevronDownIcon.js';
import '../../../icons/ChevronRightIcon.js';
import '../../../icons/ChevronUpIcon.js';
import '../../../icons/CopyIcon.js';
import '../../../icons/CrossIcon.js';
import '../../../icons/DaiIcon.js';
import '../../../icons/DangerIcon.js';
import '../../../icons/DownSortIcon.js';
import '../../../icons/ExclamationTriangleIcon.js';
import '../../../icons/ExpandKpiIcon.js';
import '../../../icons/EyeIcon.js';
import '../../../icons/EyeSlashIcon.js';
import '../../../icons/Grid1x2Icon.js';
import '../../../icons/InfoCircleIcon.js';
import '../../../icons/ListIcon.js';
import '../../../icons/LockIcon.js';
import '../../../icons/MediumIcon.js';
import '../../../icons/MoonIcon.js';
import '../../../icons/PiggyBankIcon.js';
import '../../../icons/QuestionMarkCircleIcon.js';
import '../../../icons/ShieldIcon.js';
import '../../../icons/SunIcon.js';
import '../../../icons/UpSortIcon.js';
import '../../../icons/XIcon.js';
import '../../../atoms/Input/Input.js';
import '../../../atoms/ToggleSwitch.js';
import '../../../atoms/Table/Table.js';
import '../../../atoms/Table/components/HeaderCell/HeaderCell.js';
import '@floating-ui/react';
import '../../../atoms/Tooltip/components/TooltipContext.js';
import '../../../atoms/Tooltip/components/TooltipContent.js';
import '../../../atoms/Tooltip/components/TooltipTrigger.js';
import '../../../atoms/Table/components/Pagination/Pagination.js';
import '../../../atoms/layout/Stack/Stack.js';
import 'ethereum-blockies-base64';
import '../../../molecules/CurrencyValue/components/Value.js';
import '../../../pictograms/EthPictogram.js';
import '../../../pictograms/EtherScanPictogram.js';
import '../../../pictograms/DebankPictogram.js';
import '../../../pictograms/ZapperPictogram.js';
import '../../../pictograms/DaiPictogram.js';
import '../../../molecules/TrendValue.js';
import '../../../molecules/KpiCard/KpiCard.js';
import '../../../molecules/Tabs/Tabs.js';
import '../../ChartKpis/ChartKpi.js';
import '../../ChartJS.js';
import '../Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../../XRay.js';

const Value = styled.span `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  word-wrap: normal;
  border: 0;
`;
const HeatmapCell = forwardRef(function Cell({ children, ...rest }, ref) {
    return (jsx(ThemedComponentWrapper, { ...rest, name: "heatmapCell", ref: ref, children: jsx(Value, { children: children }) }));
});

export { HeatmapCell as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhdG1hcENlbGwuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2NoYXJ0cy9IZWF0bWFwL2NvbXBvbmVudHMvSGVhdG1hcENlbGwudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBUaGVtZWRDb21wb25lbnRXcmFwcGVyIH0gZnJvbSAnQGluZGV4JztcbmltcG9ydCB7IFRoZW1lZENvbXBvbmVudFdyYXBwZXJQcm9wcyB9IGZyb20gJy4uLy4uLy4uLy4uL3RoZW1lL1RoZW1lZENvbXBvbmVudFdyYXBwZXInO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdzdHlsZWQtY29tcG9uZW50cyc7XG5cbmNvbnN0IFZhbHVlID0gc3R5bGVkLnNwYW5gXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgd2lkdGg6IDFweDtcbiAgaGVpZ2h0OiAxcHg7XG4gIHBhZGRpbmc6IDA7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIGNsaXA6IHJlY3QoMCwgMCwgMCwgMCk7XG4gIHdvcmQtd3JhcDogbm9ybWFsO1xuICBib3JkZXI6IDA7XG5gO1xuXG5pbnRlcmZhY2UgSGVhdG1hcENlbGxQcm9wc1xuICBleHRlbmRzIE9taXQ8VGhlbWVkQ29tcG9uZW50V3JhcHBlclByb3BzPCd0ZCc+LCAnbmFtZSc+IHt9XG5cbmNvbnN0IEhlYXRtYXBDZWxsID0gZm9yd2FyZFJlZihmdW5jdGlvbiBDZWxsKFxuICB7IGNoaWxkcmVuLCAuLi5yZXN0IH06IEhlYXRtYXBDZWxsUHJvcHMsXG4gIHJlZlxuKSB7XG4gIHJldHVybiAoXG4gICAgPFRoZW1lZENvbXBvbmVudFdyYXBwZXIgey4uLnJlc3R9IG5hbWU9XCJoZWF0bWFwQ2VsbFwiIHJlZj17cmVmfT5cbiAgICAgIDxWYWx1ZT57Y2hpbGRyZW59PC9WYWx1ZT5cbiAgICA8L1RoZW1lZENvbXBvbmVudFdyYXBwZXI+XG4gICk7XG59KTtcblxuZXhwb3J0IGRlZmF1bHQgSGVhdG1hcENlbGw7XG4iXSwibmFtZXMiOlsiX2pzeCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBS0EsTUFBTSxLQUFLLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQSxDQUFBOzs7Ozs7Ozs7Q0FTeEIsQ0FBQztBQUtGLE1BQU0sV0FBVyxHQUFHLFVBQVUsQ0FBQyxTQUFTLElBQUksQ0FDMUMsRUFBRSxRQUFRLEVBQUUsR0FBRyxJQUFJLEVBQW9CLEVBQ3ZDLEdBQUcsRUFBQTtJQUVILFFBQ0VBLElBQUMsc0JBQXNCLEVBQUEsRUFBQSxHQUFLLElBQUksRUFBRSxJQUFJLEVBQUMsYUFBYSxFQUFDLEdBQUcsRUFBRSxHQUFHLFlBQzNEQSxHQUFDLENBQUEsS0FBSyxjQUFFLFFBQVEsRUFBQSxDQUFTLEVBQ0YsQ0FBQSxFQUN6QjtBQUNKLENBQUM7Ozs7In0=
